import { render, staticRenderFns } from "./PricingTabButtonsEx.vue?vue&type=template&id=860688f8&scoped=true"
import script from "./PricingTabButtonsEx.vue?vue&type=script&lang=js"
export * from "./PricingTabButtonsEx.vue?vue&type=script&lang=js"
import style0 from "./PricingTabButtonsEx.vue?vue&type=style&index=0&id=860688f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860688f8",
  null
  
)

export default component.exports